import React from 'react';
// @ts-ignore -- no @types/react-beautiful-dnd in this project
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import DragIcon from '../../../../images/drag.png';

interface GroupItem {
  id: string;
  groupName: string;
  taps: any[];
  index: number;
}

interface SortGroupsListProps {
  groupOrder: GroupItem[];
  onDragEnd: (param: any) => void;
}

const getItemStyle = (_isDragging: boolean, draggableStyle: any) => ({
  userSelect: 'none' as const,
  padding: 16,
  margin: '0 0 12px 0',
  border: '1px solid #ccc',
  background: 'white',
  borderRadius: '8px',
  ...draggableStyle
});

export const SortGroupsList: React.FC<SortGroupsListProps> = ({ groupOrder, onDragEnd }) => {
  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="droppable">
        {(provided: any) => (
          <div {...provided.droppableProps} ref={provided.innerRef}>
            {groupOrder.map((data, index) => (
              <Draggable key={data.id} draggableId={data.id} index={index}>
                {(provided: any, snapshot: any) => (
                  <div
                    className="flex flex-row items-center"
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}>
                    <img className="mr-2" width={24} src={DragIcon} alt="Drag and Drop Icon" />
                    <p>{data.groupName}</p>
                  </div>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};
